import { createTheme, Theme } from "@mui/material";
import themeOptions from "./theme-options";

let theme: Theme = createTheme({
  custom: {
    sidebarWidth: 0,
    mobileSidebarWidth: 0,
    desktopSidebarWidth: 0,
  },
});

theme = createTheme(themeOptions(theme));

export default theme;
